var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RTCHeaderDesktop1 } from "./RTCHeaderDesktop1";
import { RTCHeaderDesktop4 } from "./RTCHeaderDesktop4";
import { useState } from "react";
export function RTCHeaderDesktop(_a) {
    var { skin } = _a, props = __rest(_a, ["skin"]);
    const [searchOpen, setSearchOpen] = useState(false);
    switch (skin) {
        case "1":
            return (_jsx(RTCHeaderDesktop1, Object.assign({}, props, { searchOpen: searchOpen, setSearchOpen: setSearchOpen }), void 0));
        case "4":
            return (_jsx(RTCHeaderDesktop4, Object.assign({}, props, { searchOpen: searchOpen, setSearchOpen: setSearchOpen }), void 0));
        default:
            return (_jsx(RTCHeaderDesktop1, Object.assign({}, props, { searchOpen: searchOpen, setSearchOpen: setSearchOpen }), void 0));
    }
}
//# sourceMappingURL=RTCHeaderDesktop.js.map